import { FormikContextType } from 'formik';
import React from 'react';
import ConfirmationDialog from '../common/confirmationDialog';
import ConfirmationModal from '../report/customViewModal/confirmationModal';

interface NavigationWarningProps {
  formik: FormikContextType<any>;
  displayDirtyWarning: boolean;
  confirmNavigationWarning: () => void;
  cancleNavigationWarning: () => void;
}

const NavigationWarning = ({
  formik,
  displayDirtyWarning,
  confirmNavigationWarning,
  cancleNavigationWarning
}: NavigationWarningProps) => {
  return (
    <ConfirmationModal
      open={formik.dirty && displayDirtyWarning}
      closeModal={() => {}}
      children={
        <ConfirmationDialog
          title="Confirmation"
          message="You have unsaved changes. Are you sure you would like to leave?"
          confirmAction={confirmNavigationWarning}
          cancelAction={cancleNavigationWarning}
        />
      }
    />
  );
};

export default NavigationWarning;
